import React, { useState } from "react";
import ajaxUser from "../util/remote/ajaxUser";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import functions from "../util/functions";
function ActivateAccount() {
  const [pass, setPass] = useState("");
  const [pass2, setPass2] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const user_id = functions.sessionGuard(); // get user id from token/session
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (pass !== pass2) {
      toast.error("Passwords don't match");
      return;
    }
    const hashedPassword = btoa(pass);
    const data = { user_id: user_id, password: hashedPassword };
    const server_response = await ajaxUser.ActivateAccount(data);
    if (server_response.status === "OK") {
      localStorage.removeItem("FuelFy@daisy");
      toast.success(server_response.message);
      navigate("/");
      window.location.reload();
    } else {
      toast.error(server_response.message);
    }
  };
  return (
    <div
      className="login-container"
      style={{
        width: "100%",
        height: "100vh",
        backgroundImage: `url(${process.env.PUBLIC_URL}/login_bg_2.jpg)`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
      }}
    >
      <Toaster />
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background: "rgba(0,0,0,0.55)",
          backdropFilter: "blur(2px)",
        }}
      ></div>
      <div
        className="login-card"
        style={{
          width: "380px",
          padding: "35px",
          borderRadius: "18px",
          background: "rgba(255,255,255,0.12)",
          backdropFilter: "blur(14px)",
          boxShadow: "0 8px 30px rgba(0,0,0,0.25)",
          color: "#fff",
          zIndex: 2,
        }}
      >
        <div className="text-center mb-3">
          <img
            src={process.env.PUBLIC_URL + "/assets/img/brand/logo.png"}
            alt="logo"
            style={{ height: "60px" }}
          />
        </div>
        <h3 className="text-center mb-3" style={{ fontWeight: 600 }}>
          Activate Account
        </h3>
        <form onSubmit={handleSubmit}>
          {/* Password */}
          <div className="form-group mb-3" style={{ position: "relative" }}>
            <label style={{ fontWeight: 500 }}>New Password</label>
            <input
              className="form-control"
              type={showPassword ? "text" : "password"}
              placeholder="Enter new password"
              value={pass}
              autoComplete="off"
              autoCorrect="off"
              autoCapitalize="none"
              spellCheck="false"
              onChange={(e) => setPass(e.target.value)}
              style={{
                background: "rgba(255,255,255,0.85)",
                border: "none",
                borderRadius: "10px",
                paddingRight: "40px",
              }}
            />
            <i
              className={`fa-solid ${showPassword ? "fa-eye-slash" : "fa-eye"}`}
              onClick={() => setShowPassword(!showPassword)}
              style={{
                position: "absolute",
                right: "12px",
                top: "35px",
                cursor: "pointer",
                fontSize: "18px",
                color: "#333",
              }}
            ></i>
          </div>
          {/* Confirm Password */}
          <div className="form-group mb-4">
            <label style={{ fontWeight: 500 }}>Confirm Password</label>
            <input
              className="form-control"
              type={showPassword ? "text" : "password"}
              placeholder="Repeat password"
              value={pass2}
              autoComplete="off"
              autoCorrect="off"
              autoCapitalize="none"
              spellCheck="false"
              onChange={(e) => setPass2(e.target.value)}
              style={{
                background: "rgba(255,255,255,0.85)",
                border: "none",
                borderRadius: "10px",
              }}
            />
          </div>
          {/* Button */}
          <button
            className="btn btn-primary btn-block"
            style={{
              width: "100%",
              borderRadius: "10px",
              padding: "10px",
              fontWeight: 600,
              backgroundColor: "#3167eb",
              border: "none",
              cursor: "pointer",
            }}
          >
            Activate Account
          </button>
        </form>
      </div>
    </div>
  );
}
export default ActivateAccount;
